<template lang='pug'>
v-container(class='pl-0 pr-0' fluid grid-list-xl)
  v-layout(row wrap)
    v-flex(v-for='image in images' :key='image.url' xs12 sm6)
      v-img(
        :src='image.url'
        :lazy-src='image.url'
        class='grey lighten-4'
      )
        v-layout(
          slot='placeholder'
          fill-height align-center justify-center ma-0
        )
          v-progress-circular(indeterminate color='primary')
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      default: () => []
    }
  }
}
</script>
